import { useEffect, useState } from 'react';
import { Button, Icon, Label } from '@facephi/ui-react';

export type Props = {
  items: number;
  onClick?(): void;
  testId?: string;
};

export const DeleteItem = ({ items, onClick, testId }: Props) => {
  const [itemsSelected, setItems] = useState<number>(items);
  useEffect(() => {
    setItems(items);
  }, [items]);

  return (
    <>
      {itemsSelected > 0 && (
        <Button testId={testId} variant="text" onClick={onClick}>
          <Icon size="24" iconName="TrashSimple" color="primary400" />
          <Label color="primary400" fontSize="16" semibold>
            Delete {itemsSelected} elements
          </Label>
        </Button>
      )}
    </>
  );
};
